import React from "react";
import type {CurrencyAbbreviation} from "./CurrencyClasses";

export const CurrencyAbbreviationContext = React.createContext<CurrencyAbbreviation | undefined>(undefined);
